/**
 * Types publications multi-plateforme — alias FE typés sur le codegen
 * OpenAPI (S6 PR2-D quater — successeur de `etsy-publications.ts`).
 *
 * Source de vérité : `backend/app/schemas/publications.py`. Pas de
 * mapper BE↔FE — les rows sont consommées telles quelles côté hooks.
 *
 * Refactor 2026-05-10 : `EtsyListingResponse` → `PlatformResourceResponse`
 * avec `state_metadata: dict | null` portant les champs spécifiques
 * plateforme. `external_id: string` (au lieu de `etsy_listing_id: int`)
 * pour couvrir Pinterest pin ids alphanumériques.
 */

import type { components } from './api-generated'

export type Platform = components['schemas']['Platform']

export type PlatformResourceResponse = components['schemas']['PlatformResourceResponse']
export type PlatformResourceMockupSummary = components['schemas']['PlatformResourceMockupSummary']
export type PlatformPublishRequest = components['schemas']['PlatformPublishRequest']
export type PlatformPublishEnqueueResponse = components['schemas']['PlatformPublishEnqueueResponse']

// `PlatformEndRequest` schema BE existe mais n'est pas exposé dans
// openapi.json en S6 (aucune route ne le consomme encore — PR2-C
// l'introduira via DELETE /publications/{platform}/{resource_id}).
// `PublicationEndedReason` enum suit le même pattern.

// ──────────────────────────────────────────────────────────────────────────────
// Helpers d'affichage UI — labels FR Etsy-spécifiques
// (gardés ici car consommés par <PlatformPublishCard platform="etsy">.
// Quand Pinterest arrivera S7+, ajouter `PINTEREST_STATE_FR` etc.)
// ──────────────────────────────────────────────────────────────────────────────

export const ETSY_LISTING_STATE_FR: Record<string, string> = {
  draft: 'Brouillon',
  active: 'En ligne',
  sold_out: 'Épuisé',
  edited: 'Édition…',
  ended: 'Retiré',
  deleted: 'Supprimé définitivement',
}

// Labels FR plateforme — pour affichage cross-plateforme dans le journal
// PR4. Pinterest/Insta/TikTok ajoutés ici quand les adapters arriveront S7+.
export const PLATFORM_LABEL_FR: Record<string, string> = {
  etsy: 'Etsy',
  pinterest: 'Pinterest',
  instagram: 'Instagram',
  tiktok: 'TikTok',
  saatchi: 'Saatchi',
  artfinder: 'Artfinder',
}
